import { render, staticRenderFns } from "./adds.vue?vue&type=template&id=5497b77b&scoped=true"
import script from "./adds.vue?vue&type=script&lang=js"
export * from "./adds.vue?vue&type=script&lang=js"
import style0 from "./adds.vue?vue&type=style&index=0&id=5497b77b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497b77b",
  null
  
)

export default component.exports